import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';

import { Form as FormFinal, Field } from 'react-final-form';
import { Button, Alert, Card, Form, Col, Spinner, Table } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone'

import { DeleteDismiss } from '@styled-icons/fluentui-system-regular/DeleteDismiss';
import { AddToQueue } from '@styled-icons/boxicons-regular/AddToQueue';

//Actions
import { pesquisa as pesquisaupload, novoatualiza, deletar } from '../../../../actions/upload/uploadpdf';
import { pesquisaBaseCategorias } from '../../../../actions/forms/validacao';

//Components
import { camposelect } from '../../../../components/forms/campos/campos';

//Utils
import { getEvento } from '../../../../utils/eventosession';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

const FormUploadPdf  = (props) => {
    
    const evento = getEvento();
    const parametros = {idpromotora: evento.idpromotora, idevento: evento.idevento};

    const [showGravado, handleCloseModalGravado] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [uploads, setUploads] = useState([]);
    const [codepdf, setUrl] = useState(null);
    const [previewpdf, setPreviewpdf] = useState(null);

    useEffect(() => {
        load();        
    },[]);
    
    const handleModalGravado = () => {
        handleCloseModalGravado(showGravado===true?false:false);
    }

    const load = async () => {        
        setCategorias(await props.pesquisaBaseCategorias(parametros));
        setUploads(await props.pesquisaupload({...parametros, campo: 'template_pdf_credencial'}));
    }

    const handleSubmitForm = async (form) => {
        const formdados = new FormData();
        formdados.append('idpromotora', evento.idpromotora);
        formdados.append('idevento', evento.idevento);       
        formdados.append('identificacaogenerico', form.identificacaogenerico); 
        formdados.append('template_pdf_credencial', codepdf);        
        await props.novoatualiza(formdados);
        setUrl(null);
        load();
    }

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            const reader = new FileReader();        
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {
                const blob = reader.result;
                const b64payload = reader.result;
                const file = new Blob([blob], {type: 'application/pdf'});
                const fileURL = window.URL.createObjectURL(file);
                setPreviewpdf(fileURL);             
                console.log(b64payload);
                setUrl(b64payload);
            }
            reader.readAsText(file)
        })        
    }, []);

    const {getRootProps, getInputProps} = useDropzone({onDrop})

    const handleExcluirSelecionado = async (id) => {
        if(window.confirm('Deseja realmnte deletar este upload?')){
            await props.deletar({'_id': id, idpromotora: evento.idpromotora});
            load();
        }
    }
    
    return (
        <>        
        <FormFinal
        onSubmit={handleSubmitForm}
        validate={(form) => {
            const errors = {};
            if(!form.identificacaogenerico){
                errors.identificacaogenerico = 'Obrigatório';
            }            
            return errors;
        }}
        render={({form, handleSubmit, submitting, submitSucceeded, errors}) => {
            return (                
                <Card>                        
                    <Card.Header><Card.Title>UPLOAD</Card.Title></Card.Header>
                    <TelaModalLivre handleCloseModal={handleModalGravado} show={showGravado} titulo="Resultado PDF">
                        <Alert variant="success">Gravado com sucesso</Alert>
                    </TelaModalLivre>                    
                    <Card.Body>      
                        {uploads.length?
                        <Table striped bordered hover className="col col-lg-4">
                            <thead>
                                <tr>                            
                                <th>Credencial PDF</th>
                                <th>Remover</th>                            
                                </tr>
                            </thead>                        
                            <tbody>
                                {uploads.map(files => {
                                    const modelo = categorias.filter(itens => itens.categoria === files.identificacaogenerico);
                                    return (
                                    <tr key={files._id}>
                                        <td>{modelo[0]?modelo[0].descricao:null}</td>
                                        <td><DeleteDismiss style={{cursor: "pointer"}} size="35" type="button" onClick={() => handleExcluirSelecionado(files._id, form)} /></td>
                                    </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                        :
                        null
                        }                  
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                            <Form.Row>                            
                                <Form.Group controlId="identificacaogenerico" as={Col} md="8">
                                    <Field name="identificacaogenerico" id="identificacaogenerico" label="Qual o formulário" component={camposelect}
                                        options={[
                                            {texto: 'Escolha', value: ''}, 
                                            ...categorias.map(itens => {
                                                const existe = uploads.filter(file => (file.identificacaogenerico===itens.categoria));
                                                if(existe.length){
                                                    return {};
                                                }
                                                return (
                                                    {texto: itens.descricao, value: itens.categoria}
                                                )
                                            })
                                        ]}
                                        placeholder="Selecione o tipo"
                                        form={form}                                        
                                    />
                                </Form.Group>
                            </Form.Row>                            
                            <Card className='mb-4'>
                                <Card.Body {...getRootProps()}>
                                    <Alert variant='info'>
                                        <input 
                                        {...getInputProps()}
                                        accept=".pdf"
                                        />
                                        <p><AddToQueue size="2em" />Arraste e solte o arquivo aqui ou clique para selecionar o arquivo</p>
                                        {codepdf?<Alert variant='success'>Arquivo OK</Alert>:null}
                                    </Alert>
                                </Card.Body>                                
                            </Card>
                            <Form.Row className="text-center">
                                <Form.Group controlId="corpo" as={Col} md="8">
                                    <Button type="submit" block disabled={submitting||!codepdf}>
                                        {submitting?<Spinner animation="border" />:'Enviar'}
                                    </Button>                                    
                                </Form.Group>
                            </Form.Row>
                        </form>
                    </Card.Body>
                </Card>                
            )
        }}
        >
        </FormFinal>
        </>
    );
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,        
    }
}

export default connect(mapStateToProps, { pesquisaupload, novoatualiza, pesquisaBaseCategorias, deletar })(FormUploadPdf);